import React from "react";

const ViewIcon = () => {
  return (
    <svg
      viewBox="0 0 48 48"
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="icon-a">
          <stop offset="0" />
          <stop stopOpacity="0" offset="1" />
        </linearGradient>
        <linearGradient
          id="icon-l"
          x2="0"
          y1="-150.7"
          y2="327.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" offset="0" />
          <stop offset=".5" />
          <stop stopOpacity="0" offset="1" />
        </linearGradient>
        <linearGradient
          id="icon-o"
          x1="27.366"
          x2="31.336"
          y1="26.58"
          y2="30.558"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8a8a8a" offset="0" />
          <stop stopColor="#484848" offset="1" />
        </linearGradient>
        <linearGradient
          id="icon-n"
          x1="33.94"
          x2="37.36"
          y1="36.443"
          y2="32.65"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7d7d7d" offset="0" />
          <stop stopColor="#b1b1b1" offset=".5" />
          <stop stopColor="#686868" offset="1" />
        </linearGradient>
        <linearGradient
          id="icon-m"
          x1="18.293"
          x2="17.501"
          y1="13.602"
          y2="25.743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" offset="0" />
          <stop stopColor="#fff" stopOpacity=".21905" offset=".5" />
          <stop stopColor="#fff" offset="1" />
        </linearGradient>
        <radialGradient
          id="icon-h"
          cx="11.898"
          cy="4.5256"
          r="36.554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#a3a3a3" offset="0" />
          <stop stopColor="#4c4c4c" offset="1" />
        </radialGradient>
        <radialGradient
          id="icon-g"
          cx="32.625"
          cy="37.207"
          r="83.283"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fafafa" offset="0" />
          <stop stopColor="#bbb" offset="1" />
        </radialGradient>
        <radialGradient
          id="icon-f"
          cx="11.239"
          cy="8.1525"
          r="36.948"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" offset="0" />
          <stop stopColor="#f8f8f8" offset="1" />
        </radialGradient>
        <radialGradient
          id="icon-e"
          cx="9.4125"
          cy="30.297"
          r="1.2073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#f0f0f0" offset="0" />
          <stop stopColor="#9a9a9a" offset="1" />
        </radialGradient>
        <radialGradient
          id="icon-d"
          cx="9.4125"
          cy="18.811"
          r="1.2076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#f0f0f0" offset="0" />
          <stop stopColor="#9a9a9a" offset="1" />
        </radialGradient>
        <radialGradient
          id="icon-j"
          cx="18.241"
          cy="21.818"
          r="8.3085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#729fcf" stopOpacity=".20784" offset="0" />
          <stop stopColor="#729fcf" stopOpacity=".67619" offset="1" />
        </radialGradient>
        <radialGradient
          id="icon-i"
          cx="15.414"
          cy="13.078"
          r="6.6562"
          gradientTransform="matrix(2.593 -7.7469e-24 -5.7144e-24 2.2521 -25.06 -18.941)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" offset="0" />
          <stop stopColor="#fff" stopOpacity=".24762" offset="1" />
        </radialGradient>
        <radialGradient
          id="icon-b"
          cx="605.71"
          cy="486.65"
          r="117.14"
          gradientTransform="matrix(-2.7744 0 0 1.9697 112.76 -872.89)"
          gradientUnits="userSpaceOnUse"
        />
        <radialGradient
          id="icon-c"
          cx="605.71"
          cy="486.65"
          r="117.14"
          gradientTransform="matrix(2.7744 0 0 1.9697 -1891.6 -872.89)"
          gradientUnits="userSpaceOnUse"
        />
        <radialGradient
          id="icon-k"
          cx="24.13"
          cy="37.968"
          r="16.529"
          gradientTransform="matrix(1 0 0 .23797 -8.8211e-16 28.933)"
          gradientUnits="userSpaceOnUse"
        />
      </defs>
      <g transform="matrix(.021652 0 0 .014857 43.008 42.685)">
        <path
          d="m-1559.3-150.7h1339.6v478.36h-1339.6z"
          fill="url(#icon-l)"
          opacity=".40206"
        />
        <path
          d="m-219.62-150.68v478.33c142.87 0.90045 345.4-107.17 345.4-239.2s-159.44-239.13-345.4-239.13z"
          fill="url(#icon-c)"
          opacity=".40206"
        />
        <path
          d="m-1559.3-150.68v478.33c-142.87 0.90045-345.4-107.17-345.4-239.2s159.44-239.13 345.4-239.13z"
          fill="url(#icon-b)"
          opacity=".40206"
        />
      </g>
      <path
        d="m7.7526 3.6464h32.577a1.149 1.149 0 0 1 1.149 1.149v38.622a1.149 1.149 0 0 1 -1.149 1.149h-32.577a1.149 1.149 0 0 1 -1.149 -1.149v-38.622a1.149 1.149 0 0 1 1.149 -1.149"
        display="block"
        fill="url(#icon-g)"
        stroke="url(#icon-h)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m7.8151,4.58395h32.47779a.14905,.14905 0 0,1 .14905.14905v38.64829a.14905,.14905 0 0,1 -.14905.14905h-32.47779a.14905,.14905 0 0,1 -.14905-.14905v-38.64829a.14905,.14905 0 0,1 .14905-.14905"
        display="block"
        fill="none"
        stroke="url(#icon-f)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g transform="translate(.64645 -.037989)">
        <g transform="matrix(.2297 0 0 .2297 4.9671 4.245)" fill="#fff">
          <path d="m23.428 113.07c0 1.973-1.6 3.572-3.573 3.572s-3.573-1.6-3.573-3.572 1.6-3.573 3.573-3.573 3.573 1.6 3.573 3.573z" />
          <path d="m23.428 63.07c0 1.973-1.6 3.573-3.573 3.573s-3.573-1.6-3.573-3.573 1.6-3.573 3.573-3.573 3.573 1.6 3.573 3.573z" />
        </g>
        <path
          d="m9.99501,29.95233c0,.4532-.36752.8205-.82073.8205s-.82073-.36752-.82073-.8205 .36752-.82073.82073-.82073 .82073.36753.82073.82073z"
          fill="url(#icon-e)"
        />
        <path
          d="m9.99501,18.46718c0,.4532-.36752.82073-.82073.82073s-.82073-.36752-.82073-.82073 .36752-.82073.82073-.82073 .82073.36753.82073.82073z"
          fill="url(#icon-d)"
        />
      </g>
      <path
        d="m11.506 5.4943v37.907"
        fill="none"
        stroke="#000"
        strokeOpacity=".01754"
        strokeWidth=".98855"
      />
      <path
        d="m12.5 5.0205v38.018"
        fill="none"
        stroke="#fff"
        strokeOpacity=".20468"
      />
      <g
        transform="matrix(.90909 0 0 1 2.3636 0)"
        fill="#9b9b9b"
        fillOpacity=".54971"
      >
        <path
          d="m15.152 9h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 11h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 13h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 15h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 17h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 19h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 21h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 23h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.068 25h9.7636a0.068204 0.065391 0 0 1 0.0682 0.06539v0.86922a0.068204 0.065391 0 0 1 -0.0682 0.06539h-9.7636a0.068204 0.065391 0 0 1 -0.0682 -0.06539v-0.86922a0.068204 0.065391 0 0 1 0.0682 -0.06539"
          display="block"
        />
        <path
          d="m15.152 29h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 31h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 33h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.152 35h21.697a0.15156 0.065391 0 0 1 0.15156 0.06539v0.86922a0.15156 0.065391 0 0 1 -0.15156 0.06539h-21.697a0.15156 0.065391 0 0 1 -0.15156 -0.06539v-0.86922a0.15156 0.065391 0 0 1 0.15156 -0.06539"
          display="block"
        />
        <path
          d="m15.106 37h15.188a0.1061 0.065391 0 0 1 0.1061 0.06539v0.86922a0.1061 0.065391 0 0 1 -0.1061 0.06539h-15.188a0.1061 0.065391 0 0 1 -0.1061 -0.06539v-0.86922a0.1061 0.065391 0 0 1 0.1061 -0.06539"
          display="block"
        />
      </g>
      <g transform="matrix(.66538 0 0 .66538 15.986 17.908)">
        <path
          transform="matrix(1.4464 0 0 1.52 -10.975 -17.752)"
          d="m40.659 37.968a16.529 3.9333 0 1 1 -33.057 0 16.529 3.9333 0 1 1 33.057 0z"
          fill="url(#icon-k)"
          fillRule="evenodd"
          opacity=".17112"
        />
        <path
          d="m18.628 3.1436c-8.1391 0-14.745 6.6057-14.745 14.745s6.6057 14.745 14.745 14.745c3.4796 0 6.551-1.3844 9.0737-3.4026-0.20538 1.0069-0.07803 2.0354 0.75614 2.7599l10.964 9.5274c1.2334 1.0713 3.0875 0.93096 4.1588-0.30246s0.93096-3.0875-0.30246-4.1588l-10.964-9.5274c-0.67153-0.58328-1.4929-0.75597-2.3062-0.64272 1.9867-2.5124 3.3648-5.5488 3.3648-8.9981 0-8.1391-6.6057-14.745-14.745-14.745zm-0.07562 1.2262c7.6395 0 13.292 4.789 13.292 13.292 0 8.6751-5.8167 13.292-13.292 13.292-7.303 0-13.292-5.4781-13.292-13.292 0-7.9841 5.8246-13.292 13.292-13.292z"
          fill="#dcdcdc"
          fillRule="evenodd"
          stroke="url(#icon-o)"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3.0058"
        />
        <path
          d="m18.603 3.0804c-8.1654 0-14.792 6.627-14.792 14.792s6.627 14.792 14.792 14.792c3.4908 0 6.5722-1.3889 9.1031-3.4136-0.20604 1.0101-0.07829 2.042 0.75859 2.7688l11 9.5582c1.2374 1.0748 3.0974 0.93397 4.1722-0.30344s0.93397-3.0974-0.30344-4.1722l-11-9.5582c-0.6737-0.58516-1.4977-0.75841-2.3137-0.6448 1.9931-2.5205 3.3757-5.5667 3.3757-9.0272 0-8.1654-6.627-14.792-14.792-14.792zm-0.07586 3.1861c6.2811 0 11.379 5.0977 11.379 11.379s-5.0977 11.379-11.379 11.379-11.379-5.0977-11.379-11.379 5.0977-11.379 11.379-11.379z"
          fill="#dcdcdc"
          fillRule="evenodd"
        />
        <path
          d="m39.507 41.578c-0.47867-2.2732 1.3973-4.8114 3.584-4.7884l-10.76-9.2581c-2.9448-0.05671-4.2695 2.2726-3.7768 4.5999l10.953 9.4466z"
          fill="url(#icon-n)"
          fillRule="evenodd"
        />
        <path
          transform="matrix(1.2457 0 0 1.2457 -3.4254 -6.177)"
          d="m28.549 18.92a11.049 11.049 0 1 1 -22.097 0 11.049 11.049 0 1 1 22.097 0z"
          fill="none"
          stroke="url(#icon-m)"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.2064"
        />
        <path
          transform="matrix(.75299,.65804,-.6489,.76087,0,0)"
          d="m43.585 0.14086h12.626a3.2112 2.2202 0 0 1 3.2112 2.2202 3.2112 2.2202 0 0 1 -3.2112 2.2202h-12.626a3.2112 2.2202 0 0 1 -3.2112 -2.2202 3.2112 2.2202 0 0 1 3.2112 -2.2202"
          fill="none"
          opacity=".43316"
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.503"
        />
        <path
          transform="matrix(1.3986 0 0 1.3986 -6.2243 -8.299)"
          d="m25.898 18.478a8.3085 8.3085 0 1 1 -16.617 0 8.3085 8.3085 0 1 1 16.617 0z"
          fill="url(#icon-j)"
          fillRule="evenodd"
          stroke="#3063a3"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.0746"
        />
        <path
          d="m18.157 7.3967c-5.2076 0-9.4246 4.217-9.4246 9.4246 0 1.504 0.42031 2.8878 1.0472 4.1499 1.2524 0.46161 2.5828 0.77568 3.9948 0.77568 6.171 0 11.099-4.8616 11.48-10.937-1.731-2.0455-4.21-3.413-7.0975-3.413z"
          fill="url(#icon-i)"
          fillRule="evenodd"
          opacity=".83422"
        />
      </g>
    </svg>
  );
};

export default ViewIcon;
